import Header from '../components/Header'
import Footer from '../components/Footer'
import { Link } from 'react-router-dom'

const SocialMediaCampaigns = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        {/* Hero Section */}
        <div className="relative bg-gray-900 overflow-hidden">
          <div className="absolute inset-0">
            <img
              className="w-full h-full object-cover opacity-40"
              src="https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2850&q=80"
              alt="Social media analytics"
            />
          </div>
          <div className="relative max-w-7xl mx-auto py-24 px-4 sm:py-32 sm:px-6 lg:px-8">
            <div className="text-center">
              <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">
                <span className="block">Strategic Social Media Campaigns</span>
                <span className="block text-indigo-400">That Build Communities & Drive Conversions</span>
              </h1>
              <p className="mt-6 max-w-3xl mx-auto text-xl text-gray-300">
                We create data-driven social campaigns that increase brand awareness, engagement, and revenue across all platforms.
              </p>
              <div className="mt-10">
                <Link
                  to="/contact"
                  className="inline-block bg-indigo-600 py-3 px-8 border border-transparent rounded-md text-base font-medium text-white hover:bg-indigo-700"
                >
                  Get Your Free Strategy Session
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Stats Section */}
        <div className="bg-white py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
              {[
                { name: 'Higher Engagement Rates', value: '3-5x' },
                { name: 'Lower Cost Per Lead', value: '60%' },
                { name: 'Increased Brand Awareness', value: '78%' },
                { name: 'More Website Traffic', value: '2-3x' },
              ].map((stat) => (
                <div key={stat.name} className="text-center p-6 bg-gray-50 rounded-lg shadow">
                  <p className="text-3xl font-bold text-indigo-600">{stat.value}</p>
                  <p className="mt-2 text-sm font-medium text-gray-500">{stat.name}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Platform Strategies Section */}
        <div id="strategy" className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="lg:text-center">
              <h2 className="text-base text-indigo-600 font-semibold tracking-wide uppercase">Our Approach</h2>
              <p className="mt-2 text-3xl font-extrabold leading-8 tracking-tight text-gray-900 sm:text-4xl">
                Platform-Specific Campaign Strategies
              </p>
              <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto">
                Tailored content and advertising for each social network's unique audience
              </p>
            </div>

            <div className="mt-16">
              <div className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 lg:grid-cols-3 md:gap-x-8 md:gap-y-10">
                {[
                  {
                    name: 'Facebook Campaigns',
                    description: 'Community building and targeted advertising',
                    icon: 'M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z',
                    features: ['Lead generation ads', 'Engagement campaigns', 'Lookalike audiences', 'Retargeting']
                  },
                  {
                    name: 'Instagram Marketing',
                    description: 'Visual storytelling that converts',
                    icon: 'M12 2c2.717 0 3.056.01 4.122.06 1.065.05 1.79.217 2.428.465.66.254 1.216.598 1.772 1.153a4.908 4.908 0 0 1 1.153 1.772c.247.637.415 1.363.465 2.428.047 1.066.06 1.405.06 4.122 0 2.717-.01 3.056-.06 4.122-.465 1.065-.217 1.79-.598 2.428-1.153a4.908 4.908 0 0 1 1.772-1.772c.637-.247 1.363-.415 2.428-.465C20.944 2.013 21.283 2 22 2',
                    features: ['Story ads', 'Reels strategy', 'Influencer collabs', 'Shopping tags']
                  },
                  {
                    name: 'LinkedIn B2B',
                    description: 'Professional networking and lead generation',
                    icon: 'M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z',
                    features: ['Thought leadership', 'Sponsored content', 'Account targeting', 'Lead gen forms']
                  },
                  {
                    name: 'Twitter (X) Engagement',
                    description: 'Real-time conversations and trends',
                    icon: 'M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z',
                    features: ['Trend participation', 'Thread campaigns', 'Poll engagement', 'Community building']
                  },
                  {
                    name: 'TikTok Viral',
                    description: 'Authentic content for Gen Z',
                    icon: 'M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm4.441 16.892c-2.102.144-6.784.144-8.883 0C5.282 16.736 5.018 15.622 5 12c.018-3.629.285-4.736 2.558-4.892 2.099-.144 6.782-.144 8.883 0C18.718 7.264 18.982 8.378 19 12c-.018 3.629-.285 4.736-2.559 4.892zM10 9.658l4.917 2.338L10 14.342V9.658z',
                    features: ['Hashtag challenges', 'Duet campaigns', 'Creator partnerships', 'Trend riding']
                  },
                  {
                    name: 'YouTube Presence',
                    description: 'Video content that educates and entertains',
                    icon: 'M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z',
                    features: ['Pre-roll ads', 'Influencer takeovers', 'SEO optimization', 'Playlist strategy']
                  }
                ].map((platform) => (
                  <div key={platform.name} className="relative bg-white p-6 rounded-lg border border-gray-200 shadow-sm flex flex-col h-full">
                    <div className="flex-shrink-0 bg-indigo-100 rounded-full h-12 w-12 flex items-center justify-center">
                      <svg className="h-6 w-6 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={platform.icon} />
                      </svg>
                    </div>
                    <h3 className="mt-4 text-lg font-medium text-gray-900">
                      {platform.name}
                    </h3>
                    <p className="mt-2 text-sm text-gray-500">
                      {platform.description}
                    </p>
                    <ul className="mt-4 space-y-2 flex-grow">
                      {platform.features.map((feature) => (
                        <li key={feature} className="flex items-start">
                          <svg className="flex-shrink-0 h-5 w-5 text-indigo-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                          </svg>
                          <span className="ml-2 text-sm text-gray-700">{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Campaign Process */}
        <div className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="lg:text-center">
              <h2 className="text-base text-indigo-600 font-semibold tracking-wide uppercase">Our Process</h2>
              <p className="mt-2 text-3xl font-extrabold leading-8 tracking-tight text-gray-900 sm:text-4xl">
                From Strategy to Execution
              </p>
            </div>

            <div className="mt-16">
              <div className="lg:grid lg:grid-cols-5 lg:gap-x-8">
                {[
                  {
                    name: 'Research',
                    description: 'Audience analysis & platform selection',
                    icon: 'M19 21V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5m-4 0h4'
                  },
                  {
                    name: 'Planning',
                    description: 'Content calendar & campaign mapping',
                    icon: 'M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2M9 5a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01'
                  },
                  {
                    name: 'Creation',
                    description: 'Content production & ad development',
                    icon: 'M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122'
                  },
                  {
                    name: 'Launch',
                    description: 'Campaign deployment & optimization',
                    icon: 'M13 7h8m0 0v8m0-8l-8 8-4-4-6 6'
                  },
                  {
                    name: 'Analyze',
                    description: 'Performance tracking & reporting',
                    icon: 'M9 19v-6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2zm0 0V9a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v10m-6 0a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2m0 0V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2z'
                  }
                ].map((step) => (
                  <div key={step.name} className="group relative p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500">
                    <div>
                      <div className="inline-flex rounded-lg bg-indigo-50 p-3">
                        <svg className="h-6 w-6 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={step.icon} />
                        </svg>
                      </div>
                    </div>
                    <div className="mt-8">
                      <h3 className="text-lg font-medium">
                        <span className="absolute inset-0" aria-hidden="true" />
                        {step.name}
                      </h3>
                      <p className="mt-2 text-sm text-gray-500">
                        {step.description}
                      </p>
                    </div>
                    <span className="pointer-events-none absolute top-6 right-6 text-gray-300 group-hover:text-indigo-400" aria-hidden="true">
                      <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M20 4h1a1 1 0 00-1-1v1zm-1 12a1 1 0 102 0h-2zM8 3a1 1 0 000 2V3zM3.293 19.293a1 1 0 101.414 1.414l-1.414-1.414zM19 4v12h2V4h-2zm1-1H8v2h12V3zm-.707.293l-16 16 1.414 1.414 16-16-1.414-1.414z" />
                      </svg>
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Case Study */}
        <div className="bg-indigo-700 py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="lg:grid lg:grid-cols-2 lg:gap-8">
              <div className="mb-8 lg:mb-0">
                <h2 className="text-3xl font-extrabold text-white">
                  <span className="block">230% Increase in</span>
                  <span className="block">Social Conversions</span>
                </h2>
                <p className="mt-4 text-lg text-indigo-200">
                  How we transformed a beauty brand's social presence across Instagram and TikTok, driving record-breaking sales.
                </p>
                <div className="mt-8">
                  <Link to="/case-studies" className="inline-flex items-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-indigo-600 bg-white hover:bg-indigo-50">
                    View Case Study
                  </Link>
                </div>
              </div>
              <div className="bg-white rounded-lg shadow-lg p-6">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <svg className="h-12 w-12 text-indigo-600" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2h-1V9z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div className="ml-4">
                    <blockquote>
                      <p className="text-lg text-gray-700">
                        "The viral TikTok campaign generated over 2.3 million views in the first month, completely transforming our customer acquisition strategy."
                      </p>
                      <footer className="mt-4">
                        <div className="flex items-center">
                          <div className="ml-4">
                            <div className="text-base font-medium text-gray-900">Marcus Johnson</div>
                            <div className="text-base font-medium text-indigo-600">CMO, Glow Beauty</div>
                          </div>
                        </div>
                      </footer>
                    </blockquote>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="bg-white py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
              Ready to Transform Your Social Presence?
            </h2>
            <p className="mt-4 max-w-2xl text-xl text-gray-500 mx-auto">
              Let's create social campaigns that drive real business results.
            </p>
            <div className="mt-8 flex justify-center">
              <div className="inline-flex rounded-md shadow">
                <Link
                  to="/contact"
                  className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700"
                >
                  Get Started Today
                </Link>
              </div>
              <div className="ml-3 inline-flex">
                <Link
                  to="/case-studies"
                  className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-indigo-700 bg-indigo-100 hover:bg-indigo-200"
                >
                  See Campaign Examples
                </Link>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default SocialMediaCampaigns